import { take, takeEvery, put, call, fork, select, all } from 'redux-saga/effects'


import { API_REQUESTED, API_SUCCEEDED, API_FAILED, fetchOverviewPage, setOverviewPage } from 'reducers'
import history from '../history'
import { message } from 'antd'
import api from 'utils/api'


function* fetchOverviewPageAsync(action) {
	try {
		yield put(API_REQUESTED())
		const data = yield call(() => {
			return api.fetchRevive(action.payload).then(res => res.data)
		})
		yield put(setOverviewPage(data))
	} catch (error) {
        message.error('Your session expired. Please login again.')
        history.push('/logout')
	}
}


const watchFetchOverview = takeEvery(fetchOverviewPage, fetchOverviewPageAsync)

export default function* root() {
  yield all([
    watchFetchOverview
  ])
}


// WEBPACK FOOTER //
// ./src/sagas/index.js